import { FileSource, Message } from "@/types";

import { axios } from "../axios.instance";

export type EditMessageRequest = {
  messageId: string;
  body: string;
  attachments: FileSource[];
};

export type EditMessageResponse = Message;

export const editMessage = async (body: EditMessageRequest): Promise<EditMessageResponse> => {
  const { data } = await axios.post(`/chats/messages/${body.messageId}/text/edit`, {
    body: body.body,
    attachments: body.attachments,
  });

  return data;
};
